module.exports = __webpack_public_path__ + "img/stamp.e66599bb.svg";